import * as React from 'react';
import translate from '../../../../locale/translate';

import { CheckboxInput } from '../../common/Input';
import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.checked);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Display")}</h3>
                <CheckboxInput
                    name="displaySystemsWithoutMav"
                    label={translate.gettext("Systems without MAV")}
                    checked={settings.displaySystemsWithoutMav}
                    onChange={this.handleChange.bind(this)}
                />

                <CheckboxInput
                    name="displaySystemsWithoutEvents"
                    label={translate.gettext("Systems without threads")}
                    checked={settings.displaySystemsWithoutEvents}
                    onChange={this.handleChange.bind(this)}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/listSystems/Editor.tsx